import { FormControl, MenuItem, Select, Typography } from "@mui/material";
import { useSearch } from "../../../hooks/seach/useSearch";
import { styles } from "./styles";

export default function QuantItems() {
    const {
        limit, setLimit
    } = useSearch();

    return (
        <>
            <Typography style={styles.labelInput}>
                Números de itens exibidos: *
            </Typography>

            <FormControl variant="outlined" style={styles.formControl}>
                <Select
                    onChange={e => setLimit(e.target.value)}
                    variant="outlined"
                    value={limit}
                    style={{ 'background': '#fff' }}
                >
                    <MenuItem value={8}>8</MenuItem>
                    <MenuItem value={16}>16</MenuItem>
                    <MenuItem value={32}>32</MenuItem>
                    <MenuItem value={80}>80</MenuItem>
                </Select>
            </FormControl>
        </>
    );
}